import React, { Component } from 'react';
import { connect } from 'react-redux';
import SideMenu from './SideMenu';
import TopHeader from './TopHeader';
import { setUserInfo } from '@/redux/actions/userInfo';
import { Layout } from 'antd';
import MainContent from './MainContent';
import BreadCrumb from './BreadCrumb';
import { dateToString } from '../../utils';

class Index extends Component {

	render() {
		const { breadCrumb } = this.props;
		return (
			<div className="layout">
				<Layout>
					<SideMenu />
					<Layout>
						<TopHeader />
						{breadCrumb.show ? <BreadCrumb /> : null}
						<MainContent />
						{/*<footer className="site-footer">*/}
						{/*	<div>*/}
						{/*		<p>&copy; {dateToString(new Date(), 'YYYY')} SurfaceCity. All rights reserved.</p>*/}
						{/*	</div>*/}
						{/*</footer>*/}
					</Layout>
				</Layout>
			</div>
		);
	}
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => ({
	setUserInfo: data => {
		dispatch(setUserInfo(data));
	}
});
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Index);
